import { VFlow } from 'bold-ui'
import { HistoricoPlanoPecGuiaEncaminhamentoFragment } from 'graphql/types.generated'
import HistoricoDetailTable from 'view/atendimentos/detail/historico/components/table/HistoricoDetailTable'

import { HistoricoPlanoPecGuiaEncaminhamentoPanel } from './HistoricoPlanoPecGuiaEncaminhamentoPanel'

export type HistoricoPlanoPecGuiaEncaminhamento = HistoricoPlanoPecGuiaEncaminhamentoFragment

interface HistoricoPlanoPecGuiaEncaminhamentoListProps {
  guiasEncaminhamento: ReadonlyArray<HistoricoPlanoPecGuiaEncaminhamentoFragment>
  showOnlyDwFields?: boolean
}

export default function HistoricoPlanoPecGuiaEncaminhamentoList({
  guiasEncaminhamento,
  showOnlyDwFields = false,
}: Readonly<HistoricoPlanoPecGuiaEncaminhamentoListProps>) {
  return (
    <HistoricoDetailTable title='Guia de encaminhamento' hasLines>
      <VFlow>
        {guiasEncaminhamento.map((guiaEncaminhamento) => (
          <HistoricoPlanoPecGuiaEncaminhamentoPanel
            guiaEncaminhamento={guiaEncaminhamento}
            showOnlyDwFields={showOnlyDwFields}
            key={`box-cc-historico-${guiaEncaminhamento.id}`}
          />
        ))}
      </VFlow>
    </HistoricoDetailTable>
  )
}
